export function extractSkills({ content }: { content: string }): string[] {
  if (!content) {
    return []
  }

  const parser = new DOMParser()
  const doc = parser.parseFromString(content, 'text/html')
  const skills: string[] = []
  doc.querySelectorAll('p').forEach((element) => {
    if (element.textContent) {
      skills.push(element.textContent)
    }
  })
  return skills
}
